import React from 'react';
import { ChevronRight } from 'lucide-react';
import { NewsletterSection as MapSection } from './MapSection';
export function NewsletterSection() {
  return <>
      <section className="bg-neutral-900 py-20 px-8" data-id="element-139">
        <div className="max-w-2xl mx-auto text-center" data-id="element-140">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-141" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-142">
            Newsletter
          </div>
          <h2 className="font-heading text-5xl font-normal text-white mb-6" data-id="element-143">
            Stay Connected
          </h2>
          <p className="text-base text-neutral-300 mb-10 leading-relaxed" data-id="element-144">
            Subscribe to our newsletter for special sales, events, and exclusive
            offers.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-id="element-145">
            <input type="email" placeholder="Enter your email" className="flex-1 bg-neutral-800 border border-neutral-600 text-white px-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-146" />
            <button className="inline-flex items-center gap-2 px-8 py-4 bg-brand-pink border border-brand-pink hover:bg-brand-pink/90 transition-all duration-200 text-white font-medium" data-id="element-147">
              Subscribe
              <ChevronRight size={16} data-id="element-148" />
            </button>
          </div>
        </div>
      </section>
      <MapSection data-id="element-149" />
    </>;
}